<script setup>
import { computed } from 'vue';
import ChannelIcon from 'dashboard/components-next/icon/ChannelIcon.vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  inbox: {
    type: Object,
    default: () => {},
  },
  conversationType: {
    type: String,
    default: '',
  },
  hideInboxName: {
    type: Boolean,
    default: false,
  },
});

const { t } = useI18n();

const conversationBadgeLabel = computed(() => {
  if (props.conversationType === 'questions') {
    return t('CONVERSATION.MERCADO_LIBRE.QUESTION');
  }

  if (props.conversationType === 'post_sale') {
    return t('CONVERSATION.MERCADO_LIBRE.SALE');
  }

  if (props.conversationType === 'claim') {
    return t('CONVERSATION.MERCADO_LIBRE.CLAIM');
  }

  if (props.conversationType === 'facebook_comment') {
    return t('CONVERSATION.FACEBOOK.COMMENT');
  }

  if (props.conversationType === 'instagram_comment') {
    return t('CONVERSATION.INSTAGRAM.COMMENT');
  }

  return '';
});
</script>

<template>
  <div
    v-if="!hideInboxName || conversationBadgeLabel"
    :title="inbox.name"
    class="flex items-center gap-1 text-n-slate-11 text-xs min-w-0"
  >
    <ChannelIcon
      v-if="!hideInboxName"
      :inbox="inbox"
      class="size-3 ltr:mr-1 rtl:ml-1 flex-shrink-0"
    />
    <span v-if="!hideInboxName" class="truncate">
      {{ inbox.name }}
    </span>
    <span
      v-if="conversationBadgeLabel"
      class="px-1.5 py-0.5 rounded-md bg-n-violet-2 text-n-violet-11 text-xxs font-medium leading-3 flex-shrink-0"
    >
      {{ conversationBadgeLabel }}
    </span>
  </div>
</template>
